export default __webpack_public_path__ + "static/media/statistical.299f1856.svg";